'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var HeadshotTypes = /*#__PURE__*/function (HeadshotTypes) {
  HeadshotTypes["DEFAULT"] = "silo";
  HeadshotTypes["SILO"] = "silo";
  HeadshotTypes["SPOTS"] = "spots";
  HeadshotTypes["MILB"] = "milb";
  HeadshotTypes["SIXTY_SEVEN"] = "67";
  HeadshotTypes["EIGHTY_THREE"] = "83";
  return HeadshotTypes;
}({});

exports.HeadshotTypes = HeadshotTypes;
